import * as React from "react";
import { IconProps } from "../types";

const ListCheckboxIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M5.75 10.75H3.25C2.69772 10.75 2.25 11.1977 2.25 11.75V14.25C2.25 14.8023 2.69772 15.25 3.25 15.25H5.75C6.30228 15.25 6.75 14.8023 6.75 14.25V11.75C6.75 11.1977 6.30228 10.75 5.75 10.75Z"
          fill={color}
          opacity="0.3"
        />
        <path
          d="M10.25 5.25H16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.25 12.75H16.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.24399 5.64099L3.60299 6.99999L6.99999 2.58299"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 10.75H3.25C2.69772 10.75 2.25 11.1977 2.25 11.75V14.25C2.25 14.8023 2.69772 15.25 3.25 15.25H5.75C6.30228 15.25 6.75 14.8023 6.75 14.25V11.75C6.75 11.1977 6.30228 10.75 5.75 10.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default ListCheckboxIcon;
